import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setFinancialManagementPage } from 'src/redux/reducer/website.reducer';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';

const useFinancialManagementSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const getFinancialManagementSectionJson = useCallback(async (page = 1) => {
    setLoading(true);
    setError(null);

    try {
      const response = await getRequest(`${endpoints.admin_dashboard.website?.financial_management_page?.financial_management_section}`);
      console.log("🚀 ~ getFinancialManagementSectionJson ~ data:", response);
      console.log("🚀 ~ getFinancialManagementSectionJson ~ data.data:", JSON.parse(response.web_page.json_data));

      const finalResponse = JSON.parse(response.web_page.json_data);

      if (finalResponse) {
        dispatch(setFinancialManagementPage(finalResponse));
        setData(finalResponse);
      }

      return finalResponse;
    } catch (err) {
      console.error("Error fetching Financial Management section data:", err);
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  // Optional: Auto-fetch on mount
  const fetchOnMount = useCallback(() => {
    getFinancialManagementSectionJson();
  }, [getFinancialManagementSectionJson]);

  return {
    data,
    loading,
    error,
    getFinancialManagementSectionJson,
    fetchOnMount,
    refetch: getFinancialManagementSectionJson
  };
};

export default useFinancialManagementSection;
